import {Component, h} from "preact";
import styles from './style.module.scss';
import {connect} from "redux-zero/preact";
import actions from "../../../store/actions";
import {productService} from "../../../services/product-service";
import {Image, Product, Variant} from "../../../models/product";
import ProductImage from "../../product-image";
import ProductInfoDesktop from "./product-info";
import Navigation from "./navigation";
import Colors from "../../colors";
import Button from "../../button";
import {i18nService} from "../../../services/i18n-service";
import MatchingProducts from "../../matching-products";
import ShareButtons from "../../share-buttons";
import {icons} from "../../icons";
import {customerService} from "../../../services/customer-service";
import {Like} from "../../../models/customer";
import {route} from "preact-router";
import ImagePreview from "../../image-preview";
import {Dimension} from "../../../services/tracking-service";
import App from "../../app";
import {NY_CountryService} from "../../../services/country-service";

interface Props {
  toggleLike(variant: Variant, newLikeState: boolean, dimension: string);

  product: Product;
  variant: Variant;

  likes: Like[];
}

interface State {
  isLiked: boolean;
  fullscreen: { show: boolean, start: Image };
}

const mapToProps = ({likes}) => ({likes});

class DetailDesktop extends Component<Props, State> {

  constructor() {
    super();
    this.showFullscreen = this.showFullscreen.bind(this);
    this.hideFullscreen = this.hideFullscreen.bind(this);
  }

  state: State = {
    isLiked: false,
    fullscreen: {show: false, start: new Image({})}
  };

  componentDidMount(): void {
    this.updateLikeState();
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, previousContext: any): void {
    if (this.props.product && this.props.variant) {
      if (this.state.isLiked !== customerService.isVariantLiked(this.props.variant, this.props.likes)) {
        this.updateLikeState();
      }
    }
  }

  private updateLikeState() {
    if (this.props.variant) {
      this.setState({isLiked: customerService.isVariantLiked(this.props.variant, this.props.likes)})
    }
  }

  private showFullscreen(image: Image) {
    this.setState({fullscreen: {show: true, start: image}});
  }

  private hideFullscreen() {
    this.setState({fullscreen: {show: false, start: new Image({})}})
  }

  render() {
    if (!(this.props.product && this.props.variant)) {
      return (
        <div class={styles['product-not-found-container']}>
          <div className={styles['header-container']}>
            <Navigation product={this.props.product} variant={this.props.variant}/>
          </div>
          <div className={styles['no-products']}>
            <div className={styles['info-text']}>{i18nService.translate('detail_view_product_not_found')}</div>
            <div className={styles['filter-reset']}>
              <Button black={true} label={i18nService.translate('detail_view_back_to_products_button')}
                      onClickCallback={() => route('/products/')}/>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div class={styles['detail-container']}>
        <div class={styles['header-container']}>
          <Navigation product={this.props.product} variant={this.props.variant}/>
        </div>
        <div class={styles['product-container']}>
          <div class={styles['images-container']}>
            {this.props.variant.images.map((image => {
              return (
                <div class={`${styles['image']}`}>
                  <ProductImage onClickCallback={(image: Image) => this.showFullscreen(image)}
                                image={image}
                                alt={i18nService.translate(productService.getTranslationKey(this.props.product))}
                                resolution={image.type === 'CUTOUT' ? 'mid' : 'full-hd'}/>
                </div>)
            }))
            }
          </div>
          {this.state.fullscreen.show ?
            <ImagePreview onEscapeCallback={this.hideFullscreen} onClickCallback={this.hideFullscreen}
                          image={this.state.fullscreen.start}/> : null}
          <div class={styles['info-container']}>
            <div class={styles['info-sticky']}>
              <ProductInfoDesktop product={this.props.product} variant={this.props.variant}/>
              <div class={styles['separator']}/>
              <Colors product={this.props.product} selected={this.props.variant}/>

              {NY_CountryService.getCountryCode() == "fr" && <>
                <div className={styles['separator']}/>
                <div class={styles['epr']}>
                  <a href={"/legal/Extended_Producer_Responsibility_FR.pdf"} target={"_blank"}>{i18nService.translate("detail_view_epr_label")}</a>
                </div>
              </>}

              <div class={styles['separator']}/>
              {!NY_CountryService.isRestricted(App.countryCode) && <div class={styles.like}>
                <Button svg={icons.renderHeartIcon()}
                        label={i18nService.translate(this.state.isLiked ? 'detail_view_dislike_button' : 'detail_view_like_button')}
                        onClickCallback={this.handleToggleLike.bind(this)}
                        black={this.state.isLiked}
                        white={!this.state.isLiked}/>
              </div>}
              <ShareButtons show={true} variant={this.props.variant}/>
            </div>
          </div>
        </div>
        <div class={styles['matching-products-container']}>
          <MatchingProducts productId={this.props.variant.productId} variantId={this.props.variant.id}/>
        </div>
      </div>
    )
  }

  async handleToggleLike(e: Event) {
    e.stopPropagation();

    await this.props.toggleLike(this.props.variant, !this.state.isLiked, Dimension.DETAIL);

    this.updateLikeState();
  }
}

export default connect(mapToProps, actions)(DetailDesktop)
